import { initialize, reset } from 'redux-form';
import {
  OPEN_ADMIN_USER_MODAL,
  CLOSE_ADMIN_USER_MODAL,
  OPEN_ADMIN_ROLES_MODAL,
  CLOSE_ADMIN_ROLES_MODAL,
  OPEN_HEADER_MODAL,
  CLOSE_HEADER_MODAL,
  EDIT_BOOKING_MODAL,
  CANCEL_BOOKING_MODAL,
  OPEN_CURRENCY_MODAL,
  OPEN_DESCRIPTION_MODAL,
  CLOSE_DESCRIPTION_MODAL,
  CANCEL_SCHEDULED_BOOKING_MODAL,
  OPEN_SCHEDULED_BOOKING_MODAL,
  CLOSE_SCHEDULED_BOOKING_MODAL,
  OPEN_BASE_FARE_MODAL,
  CLOSE_BASE_FARE_MODAL,
  TOGGLE_ADMIN_MENU,
  OPEN_PROVIDER_APPROVAL_MODAL,
  CLOSE_PROVIDER_APPROVAL_MODAL,
} from '../../constants';
import { censorEmail, decode } from '../../helpers/queryEncryption';

const openAdminRolesModal = (type, formData) => {
  return (dispatch, getState) => {
    if (type === 'edit') {
      dispatch(initialize("AdminRolesForm", formData, true));
    }

    dispatch({
      type: OPEN_ADMIN_ROLES_MODAL,
      payload: {
        adminRolesModal: true,
        adminRolesModalType: type
      }
    });
  }
}

const closeAdminRolesModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_ADMIN_ROLES_MODAL,
      payload: {
        adminRolesModal: false
      }
    });
  }
}

const openAdminUserModal = (type, formData, isRestrict) => {
  return (dispatch, getState) => {
    if (type === 'edit') {
      let encryptData = {
        email: isRestrict ? censorEmail(decode(formData.email)) : decode(formData.email),
      };
      formData = { ...formData, ...encryptData };
      dispatch(initialize("AdminUserForm", formData, true));
    }

    dispatch({
      type: OPEN_ADMIN_USER_MODAL,
      payload: {
        adminUserModal: true,
        adminUserModalType: type
      }
    });
  }
}

const closeAdminUserModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_ADMIN_USER_MODAL,
      payload: {
        adminUserModal: false
      }
    });
  }
}

const openHeaderModal = (modalType, formData, isPreffered) => {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_HEADER_MODAL,
      payload: {
        modalType,
        actionValue: true,
        formData,
        isPreffered
      }
    });
  };
}

const closeHeaderModal = (modalType, prefillLogin) => {
  return (dispatch, getState) => {
    !prefillLogin && dispatch(reset("LoginForm"));
    dispatch(reset("VerifyPhoneNumberForm"));
    dispatch(reset("CancelReasonForm"));
    dispatch(reset("AddTipsForm"));
    dispatch({
      type: CLOSE_HEADER_MODAL,
      payload: {
        modalType,
        actionValue: false,
        isPreffered: false
      }
    });
  };
}

const openEditBookingModal = (formData) => {
  return (dispatch, getState) => {
    dispatch(initialize("EditBookingForm", formData, true));
    dispatch({
      type: EDIT_BOOKING_MODAL,
      payload: { editBookingModal: true }
    });
  };
}

const closeEditBookingModal = () => {
  return (dispatch, getState) => {
    dispatch(reset("EditBookingForm"));
    dispatch({
      type: EDIT_BOOKING_MODAL,
      payload: { editBookingModal: false }
    });
  };
}

const openCancelBookingModal = (formData) => {
  return (dispatch, getState) => {
    dispatch({
      type: CANCEL_BOOKING_MODAL,
      payload: {
        cancelBookingModal: true,
        cancelData: formData
      },
    });
  };
}

const closeCancelBookingModal = () => {
  return (dispatch, getState) => {
    dispatch(reset("CancelBookingForm"));
    dispatch({
      type: CANCEL_BOOKING_MODAL,
      payload: { cancelBookingModal: false }
    });
  };
}

const openCurrencyModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_CURRENCY_MODAL,
      payload: {
        currencyModal: true,
      }
    });
  }
}

const closeCurrencyModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_CURRENCY_MODAL,
      payload: {
        currencyModal: false
      }
    });
  }
}

const openDescriptionModal = (formData) => {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_DESCRIPTION_MODAL,
      payload: {
        jobDescriptionModal: true,
        jobDescriptionData: formData
      }
    });
  }
}

const closeDescriptionModal = () => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_DESCRIPTION_MODAL,
      payload: {
        jobDescriptionModal: false
      }
    });
  }
}

export function openCancelScheduledBookingModal(formData) {
  return (dispatch, getState) => {
    dispatch({
      type: CANCEL_SCHEDULED_BOOKING_MODAL,
      payload: {
        cancelScheduledBookingModal: true,
        cancelData: formData
      }
    });
  };
}

export function closeCancelScheduledBookingModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CANCEL_SCHEDULED_BOOKING_MODAL,
      payload: { cancelScheduledBookingModal: false }
    });
  };
}

function openScheduledBookingModal() {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_SCHEDULED_BOOKING_MODAL,
      payload: { scheduleBookingModal: true }
    });
  };
}

function closeScheduledBookingModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_SCHEDULED_BOOKING_MODAL,
      payload: { scheduleBookingModal: false }
    });
  };
}

const openBaseFareModal = (title = '', formData, formName) => {

  return async (dispatch, getState) => {
    await dispatch(initialize(formName, formData, true));
    await dispatch({
      type: OPEN_BASE_FARE_MODAL,
      payload: {
        baseFareModal: true,
        title
      }
    });

  };
}

const closeBaseFareModal = () => {
  return (dispatch, getState) => {
    dispatch(reset("BaseFareForm"));
    dispatch({
      type: CLOSE_BASE_FARE_MODAL,
      payload: { baseFareModal: false }
    });
  };
}

const toggleAdminMenu = (isOpenAdminMenu) => {
  return (dispatch, getState) => {
    if (isOpenAdminMenu) {
      document.body.classList.add('sideMenuBodyHidden');
    } else {
      document.body.classList.remove('sideMenuBodyHidden');
    }
    dispatch({
      type: TOGGLE_ADMIN_MENU,
      payload: {
        isOpenAdminMenu,
      },
    });
  }
}

function openProviderApprovalModal(data) {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_PROVIDER_APPROVAL_MODAL,
      payload: { providerApprovalModal: true, providerApprovalData: data }
    });
  };
}

function closeProviderApprovalModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_PROVIDER_APPROVAL_MODAL,
      payload: { providerApprovalModal: false, providerApprovalData: null }
    });
  };
}

export {
  openAdminRolesModal,
  closeAdminRolesModal,
  openAdminUserModal,
  closeAdminUserModal,
  openHeaderModal,
  closeHeaderModal,
  openEditBookingModal,
  closeEditBookingModal,
  openCancelBookingModal,
  closeCancelBookingModal,
  openCurrencyModal,
  closeCurrencyModal,
  openDescriptionModal,
  closeDescriptionModal,
  openScheduledBookingModal,
  closeScheduledBookingModal,
  openBaseFareModal,
  closeBaseFareModal,
  toggleAdminMenu,
  openProviderApprovalModal,
  closeProviderApprovalModal
}